import INVENTORY_API_BASE_URL from "../../config/api";
import { useState, useEffect, useRef } from "react";
import Axios from "axios";
import "./ship.css";
import { useParams, useLocation } from "react-router-dom";
import alertify from "alertifyjs";
import "alertifyjs/build/css/alertify.min.css";
import swal from "sweetalert";

const Generated = () => {
  const { numRows } = useParams();
  const location = useLocation();
  const barcodeInputRef = useRef(null);
  const selectRef = useRef(null);
  const [selectedOrderId, setSelectedOrderId] = useState("");
  const [scannedBarcodes, setScannedBarcodes] = useState([]);
  const [currentScanIndex, setCurrentScanIndex] = useState(0);
  const [numRowsIndex, setNumRowsIndex] = useState(1);
  const [scanHistory, setScanHistory] = useState([]);
  const shipmentData = location.state?.shipmentData || null;
  const [Data, setData] = useState([]);
  const [currentSectionCount, setCurrentSectionCount] = useState(0);
  const [quantityMatch, setQuantityMatch] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const allSKUs = shipmentData?.ShipmentDetails.flatMap((detail) =>
    detail.OrderDetails.map((orderDetail) => orderDetail.SKU)
  );

  const allquantity = shipmentData?.ShipmentDetails.flatMap((detail) =>
    detail.OrderDetails.map((orderDetail) => ({
      SKU: orderDetail.SKU,
      approvedquantity: orderDetail.approvedquantity,
    }))
  );

  const isScanningCompleted = currentScanIndex >= parseInt(numRows);

  const handleAddBarcode = async (barcode) => {
    if (!selectedOrderId) {
      swal({
        title: "Please Select an option",
        text: "",
        icon: "warning",
      });
      return;
    }
    const response = await Axios.get(
      `${INVENTORY_API_BASE_URL}/getKey/${barcode}`
    );
    const barcod2 = response.data.key;

    if (barcod2) {
      const matchedItem = Data.find(
        (item) => item.barcodeData?.includes(barcod2)
      );

      const containsSKU = allSKUs.some((sku) => barcod2.includes(sku));

      if (matchedItem) {
        const allScannedBarcodes = [...scannedBarcodes];
        scanHistory.forEach((scan) => {
          allScannedBarcodes.push(...scan.scannedData);
        });

        if (allScannedBarcodes.includes(barcod2)) {
          alertify.error("Barcode already scanned!");
          barcodeInputRef.current.value = "";
        } else if (!containsSKU) {
          alertify.error("Barcode does not contain any SKU!");
          barcodeInputRef.current.value = "";
        } else {
          if (currentSectionCount + 1 !== totalQuantity) {
            setQuantityMatch(false);
          } else {
            setQuantityMatch(true);
          }

          const skuInBarcode = allSKUs.find((sku) => barcod2.includes(sku));
          const skuCountInAllScannedBarcodes = allScannedBarcodes.filter((b) =>
            b.includes(skuInBarcode)
          ).length;
          const approvedQuantityForSKU = allquantity.find(
            (q) => q.SKU === skuInBarcode
          ).approvedquantity;

          if (skuCountInAllScannedBarcodes >= approvedQuantityForSKU) {
            alertify.error(
              `SKU ${skuInBarcode} has reached its approved quantity!`
            );
            barcodeInputRef.current.value = "";
            return;
          }

          setScannedBarcodes((prevBarcodes) => [...prevBarcodes, barcod2]);
          setCurrentSectionCount((prevCount) => prevCount + 1);
          barcodeInputRef.current.value = "";
          barcodeInputRef.current.focus();

          alertify.success(`Barcode Scanned: ${barcod2}`);
        }
      } else {
        alertify.error("Barcode not found!");
        barcodeInputRef.current.value = "";
      }
    }
  };

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getManageshelf`).then(
      (response) => {
        setData(response.data);
      }
    );
  }, []);

  const handleNextScan = () => {
    if (!isScanningCompleted) {
      const scannedData = scannedBarcodes;
      const newScan = {
        numRows: numRowsIndex,
        scannedData,
        count: scannedBarcodes.length,
        OrderNumber: selectedOrderId,
      };
      setScanHistory((prevHistory) => [...prevHistory, newScan]);

      setCurrentScanIndex((prevIndex) => prevIndex + 1);
      setNumRowsIndex((prevIndex) => prevIndex + 1);
      setScannedBarcodes([]);
      setSelectedOrderId("");
      barcodeInputRef.current.focus();
    }
  };

  useEffect(() => {
    if (isScanningCompleted) {
      alertify.success("Scanning completed!");
    }
  }, [isScanningCompleted]);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      const barcod1 = e.target.value;
      handleAddBarcode(barcod1);
    }
  };

  useEffect(() => {
    const clickHandler = (e) => {
      if (
        e.target !== barcodeInputRef.current &&
        e.target !== selectRef.current
      ) {
        barcodeInputRef.current.focus();
      }
    };

    document.addEventListener("click", clickHandler);

    return () => {
      document.removeEventListener("click", clickHandler);
    };
  }, []);

  const totalCount = scanHistory.reduce((total, scan) => total + scan.count, 0);

  const totalQuantity = shipmentData?.totalQuantity || 0;

  const handleCreateOutbound = async () => {
    if (!isScanningCompleted) {
      alertify(
        "Scanning is not completed. Please finish scanning before creating outbound."
      );
      return;
    }

    setIsLoading(true);
    const shipmentDataToPost = {
      totalCount: totalCount,
      totalBoxes: shipmentData.totalBoxes,
      totalWeight: shipmentData.totalWeight,
      barcodeData: scanHistory.map((scan) => ({
        BoxNo: scan.numRows,
        scannedData: scan.scannedData,
        count: scan.count,
        DistributorName: scan.DistributorName,
        OrderNum: scan.OrderNumber,
      })),
    };

    try {
      await Axios.post(
        `${INVENTORY_API_BASE_URL}/createshipment`,
        shipmentDataToPost
      );

      for (let index = 0; index < scanHistory.length; index++) {
        const scan = scanHistory[index];
        const scannedDataToSend = scan.scannedData;

        await Axios.delete(
          `${INVENTORY_API_BASE_URL}/putawayOutbound`,
          {
            data: { barcodeData: scannedDataToSend },
          }
        );

        swal({
          title: `Barcode Data Removed for Scan ${index + 1}`,
          text: "",
          icon: "success",
        });
      }

      window.location.reload();
    } catch (error) {
      alertify("Service error");
      console.error(error);
      setIsLoading(false);
    }
  };

  return (
    <div className="generated-scan-page">
      <main className="generated-scan-content">
        <header className="scan-hero">
          <div className="scan-hero-copy">
            <span className="scan-eyebrow">
              <span className="scan-eyebrow-mark" />
              OUTBOUND OPERATIONS
            </span>
            <h1>Pack and scan shipment</h1>
            <p>Scan approved books into each box, review the packing log, then create the outbound shipment.</p>
          </div>
          <span className={"scan-status" + (isScanningCompleted ? " scan-status-complete" : "")}>
            <span />
            {isScanningCompleted ? "Scanning complete" : "Box " + numRowsIndex + " of " + numRows}
          </span>
        </header>

        <section className="scan-summary-grid" aria-label="Shipment progress">
          <article className="scan-summary-card">
            <span>Current box</span>
            <strong>{isScanningCompleted ? numRows : numRowsIndex}<small> / {numRows}</small></strong>
            <small>{isScanningCompleted ? "All planned boxes scanned" : "Box being packed"}</small>
          </article>
          <article className="scan-summary-card">
            <span>Book quantity</span>
            <strong>{currentSectionCount}<small> / {totalQuantity}</small></strong>
            <small>Approved quantity scanned</small>
          </article>
          <article className="scan-summary-card">
            <span>Scanned in this box</span>
            <strong>{scannedBarcodes.length}</strong>
            <small>Current box barcodes</small>
          </article>
          <article className="scan-summary-card">
            <span>Shipment weight</span>
            <strong>{shipmentData?.totalWeight || 0}<small> kg</small></strong>
            <small>Estimated total weight</small>
          </article>
        </section>

        <section className="scan-progress-card">
          <div className="scan-progress-copy">
            <div>
              <span className="scan-section-eyebrow">QUANTITY CHECK</span>
              <strong>{currentSectionCount} of {totalQuantity} approved books scanned</strong>
            </div>
            <span className={quantityMatch ? "scan-quantity-pill" : "scan-quantity-pill scan-quantity-warning"}>
              <span />
              {quantityMatch
                ? (currentSectionCount === totalQuantity ? "Quantity matched" : "Scanning in progress")
                : "Quantity mismatch"}
            </span>
          </div>
          <div
            className="scan-progress-track"
            role="progressbar"
            aria-label="Approved quantity scanned"
            aria-valuemin={0}
            aria-valuemax={totalQuantity}
            aria-valuenow={currentSectionCount}
          >
            <span
              style={{
                width: Math.min(
                  totalQuantity ? (currentSectionCount / totalQuantity) * 100 : 0,
                  100
                ) + "%",
              }}
            />
          </div>
        </section>

        <section className="scan-workspace">
          <div className="scan-panel scan-scanner-panel">
            <div className="scan-panel-heading">
              <div>
                <span className="scan-section-eyebrow">ACTIVE BOX · {numRowsIndex}</span>
                <h2>Scan barcodes</h2>
                <p>Choose the order for this box, then use your scanner or type a barcode.</p>
              </div>
              <span className="scan-box-mark" aria-hidden="true">BOX</span>
            </div>

            <label className="scan-field">
              <span>Order ID</span>
              <select
                ref={selectRef}
                value={selectedOrderId}
                onChange={(e) => setSelectedOrderId(e.target.value)}
                disabled={isScanningCompleted}
              >
                <option value="">Select an order</option>
                {shipmentData?.ShipmentDetails?.map((detail) => (
                  <option key={detail.orderId} value={detail.orderId}>
                    {detail.orderId}
                  </option>
                ))}
              </select>
            </label>

            <label className="scan-field scan-barcode-field">
              <span>Barcode</span>
              <div className="scan-barcode-control">
                <span className="scan-search-mark" aria-hidden="true">⌕</span>
                <input
                  type="text"
                  placeholder="Scan or enter barcode"
                  ref={barcodeInputRef}
                  onKeyDown={handleKeyDown}
                  disabled={isScanningCompleted || currentSectionCount === totalQuantity}
                  autoComplete="off"
                />
                <span className="scan-enter-hint">Press Enter</span>
              </div>
            </label>

            <div className="scan-actions">
              <button
                type="button"
                className="scan-add-button"
                onClick={() => handleAddBarcode(barcodeInputRef.current.value)}
                disabled={isScanningCompleted}
              >
                Add barcode
              </button>
              <button
                type="button"
                className="scan-next-button"
                onClick={handleNextScan}
                disabled={isScanningCompleted}
              >
                Save box &amp; next <span aria-hidden="true">→</span>
              </button>
            </div>

            <div className={quantityMatch ? "scan-guidance" : "scan-guidance scan-guidance-warning"}>
              <span aria-hidden="true">{quantityMatch ? "✓" : "!"}</span>
              {quantityMatch
                ? "Barcode scans are checked against the approved SKU quantities."
                : "Review the quantity check and continue scanning the remaining books."}
            </div>
          </div>

          <aside className="scan-panel scan-overview-panel">
            <span className="scan-section-eyebrow">SHIPMENT OVERVIEW</span>
            <h2>At a glance</h2>
            <div className="scan-overview-row">
              <span>Total boxes</span>
              <strong>{shipmentData?.totalBoxes || numRows}</strong>
            </div>
            <div className="scan-overview-row">
              <span>Order quantity</span>
              <strong>{totalQuantity}</strong>
            </div>
            <div className="scan-overview-row">
              <span>Boxes saved</span>
              <strong>{scanHistory.length} of {numRows}</strong>
            </div>
            <div className="scan-overview-note">
              Each saved box keeps its order assignment and scanned barcode list.
            </div>
          </aside>
        </section>

        <section className="scan-detail-grid">
          <div className="scan-panel">
            <div className="scan-panel-heading scan-panel-heading-compact">
              <div>
                <span className="scan-section-eyebrow">PACKING LOG</span>
                <h2>Scan history</h2>
              </div>
              <span className="scan-count-chip">{scanHistory.length} saved</span>
            </div>
            {scanHistory.length === 0 ? (
              <div className="scan-empty">Saved box scans will appear here.</div>
            ) : (
              <div className="scan-history-list">
                {scanHistory.map((scan, index) => (
                  <article className="scan-history-item" key={index}>
                    <span className="scan-history-box">BOX {scan.numRows}</span>
                    <div className="scan-history-copy">
                      <strong>Order {scan.OrderNumber}</strong>
                      <span>{scan.count} {scan.count === 1 ? "barcode" : "barcodes"} scanned</span>
                    </div>
                    <span className="scan-history-check" aria-label="Saved">✓</span>
                  </article>
                ))}
              </div>
            )}
          </div>

          <div className="scan-panel">
            <div className="scan-panel-heading scan-panel-heading-compact">
              <div>
                <span className="scan-section-eyebrow">CURRENT BOX</span>
                <h2>Scanned barcodes</h2>
              </div>
              <span className="scan-count-chip">{scannedBarcodes.length} scanned</span>
            </div>
            {scannedBarcodes.length === 0 ? (
              <div className="scan-empty">Barcode entries will appear here.</div>
            ) : (
              <ul className="scan-barcode-list">
                {scannedBarcodes.map((barcode, index) => (
                  <li key={index}>
                    <span />
                    <code>{barcode}</code>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </section>

        {isLoading && (
          <div className="scan-loading" role="status">
            <span className="scan-loading-spinner" />
            Creating outbound shipment and updating shelf stock…
          </div>
        )}

        {quantityMatch && (
          <footer className="scan-outbound-footer">
            <div>
              <span className="scan-section-eyebrow">READY FOR DISPATCH</span>
              <strong>{isScanningCompleted ? "All boxes are ready" : "Finish scanning all boxes"}</strong>
              <span>
                {isScanningCompleted
                  ? "Create the outbound record and remove scanned barcodes from shelf stock."
                  : "Complete the planned box scans to enable outbound creation."}
              </span>
            </div>
            <button
              onClick={handleCreateOutbound}
              className="outboundbtn"
              disabled={!isScanningCompleted}
            >
              Create outbound <span aria-hidden="true">→</span>
            </button>
          </footer>
        )}
      </main>
    </div>
  );
};

export default Generated;
